<template>
  <div id="frame">
    <div class="header" v-if="procDone">
      <p class="cancelButton" @click="close"></p>
      <div class="head">
        <div class="title" v-if="isForm">
          <span class="bold color-blue">보험료 비교표</span>를 확인하고<br> 견적서 하단의 선호보험사도 선택해보세요!
        </div>
        <div class="title" v-else>
          <span class="bold color-blue">보험료 비교표</span>를 확인하고 견적서 하단의 선호보험사도 선택해보세요!
        </div>

        <div class="checkMyInsurance" v-if="!isMobile">
          <el-checkbox v-model="checkmyinsure">
            내 보험 점검 신청하기 <span class="grey-font">(선택)</span>
            <el-popover
              placement="top"
              width="800"
              trigger="click"
            >
              <div>
                고객님께서 현재 가입한 모든 보험 및 보장금액 내용을 한국신용정보원과 보험협회로 부터 조회하여 이메일 및 카톡으로 보내드립니다.
                결과 서류를 보시면 불필요한 보험을 정리하거나 리모델링을 종합적으로 판단하고 선택하실 수 있습니다.
              </div>

              <span slot="reference">
                <!-- <img style="display: inline-block; margin-left: 0.2rem; max-width: 1.2rem; line-height: 3.5rem; vertical-align: middle;" :src="statusHelp ? '../static/cancel_blue.png' : '../static/help_gray.png'"/> -->
                <i class="material-icons info-icon" @click="e => { e.preventDefault(); }">info</i>
              </span>
            </el-popover>
          </el-checkbox>
        </div>

        <div class="section">
          <template v-if="!isForm">
            <div class="button reservation" :class="{disabled: selectedCompany.length > 2}" v-if="selectedCompany.length == 0" @click="reservation">추천 보험사로 상담 <img :src="'../static/Shape.png'" /></div>
            <div class="button reservation" :class="{disabled: selectedCompany.length > 2}" v-if="selectedCompany.length > 0" @click="reservation">선호 보험사로 상담 <img :src="'../static/Shape.png'" /></div>
            <div class="checkMyInsurance" v-if="isMobile">
              <el-checkbox v-model="checkmyinsure">
                내 보험 점검 신청하기 <span class="grey-font">(선택)</span>
                <el-popover
                  placement="top"
                  width="800"
                  trigger="click"
                >
                  <div>
                    고객님께서 현재 가입한 모든 보험 및 보장금액 내용을 한국신용정보원과 보험협회로 부터 조회하여 이메일 및 카톡으로 보내드립니다.
                    결과 서류를 보시면 불필요한 보험을 정리하거나 리모델링을 종합적으로 판단하고 선택하실 수 있습니다.
                  </div>

                  <span slot="reference">
                    <!-- <img style="display: inline-block; margin-left: 0.2rem; max-width: 1.2rem; line-height: 3.5rem; vertical-align: middle;" :src="statusHelp ? '../static/cancel_blue.png' : '../static/help_gray.png'"/> -->
                    <i class="material-icons info-icon" @click="e => { e.preventDefault(); }">info</i>
                  </span>
                </el-popover>
              </el-checkbox>
            </div>
          </template>

          <template v-else>
            <div class="round">
              <el-form
                :model="formData"
                :rules="rules"
                ref="ruleFormTop"
              >
                <el-row :gutter="20">
                  <el-col :md="5" :sm="12" :xs="12" class="form-input">
                    <el-form-item label="이름" prop="name" class="first-input">
                      <el-input placeholder="이름을 입력해주세요" v-model="formData.name" />
                    </el-form-item>
                  </el-col>
  
                  <el-col :md="5" :sm="12" :xs="12" class="form-input">
                    <el-form-item label="생년월일" prop="birth">
                      <el-date-picker
                        v-model="formData.birth"
                        value-format="yyyy-MM-dd"
                        ref="birthDateTop"
                        class="birth-input"
                        @focus="focusBirth('birthDateTop')"
                        @change="changeBirth"
                      />
                    </el-form-item>
                  </el-col>
  
                  <el-col :md="4" :sm="12" :xs="12" class="form-input">
                    <el-form-item label="성별" prop="gender" class="gender">
                      <el-radio v-model="formData.gender" label="남성">남성</el-radio>
                      <el-radio v-model="formData.gender" label="여성">여성</el-radio>
                    </el-form-item>
                  </el-col>
  
                  <el-col :md="5" :sm="12" :xs="12" class="form-input">
                    <el-form-item label="연락처" prop="phoneNumber">
                      <el-input placeholder="연락처를 입력해주세요" v-model="formData.phoneNumber" />
                    </el-form-item>
                  </el-col>

                  <el-col :sm="24" :xs="24" v-if="isMobile">
                    <el-form-item label="">
                      <div class="checkMyInsurance">
                        <el-checkbox v-model="checkmyinsure">
                          내 보험 점검 신청하기 <span class="grey-font">(선택)</span>
                          <el-popover
                            placement="top"
                            width="800"
                            trigger="click"
                          >
                            <div>
                              고객님께서 현재 가입한 모든 보험 및 보장금액 내용을 한국신용정보원과 보험협회로 부터 조회하여 이메일 및 카톡으로 보내드립니다.
                              결과 서류를 보시면 불필요한 보험을 정리하거나 리모델링을 종합적으로 판단하고 선택하실 수 있습니다.
                            </div>
    
                            <span slot="reference">
                              <!-- <img style="display: inline-block; margin-left: 0.2rem; max-width: 1.2rem; line-height: 3.5rem; vertical-align: middle;" :src="statusHelp ? '../static/cancel_blue.png' : '../static/help_gray.png'"/> -->
                              <i class="material-icons info-icon" @click="e => { e.preventDefault(); }">info</i>
                            </span>
                          </el-popover>
                        </el-checkbox>
                      </div>
                    </el-form-item>
                  </el-col>
  
                  <el-col :md="5" :sm="24" :xs="24">
                    <el-form-item label="">
                      <el-button
                        type="primary"
                        class="submit-btn"
                        round
                        @click="validForm('ruleFormTop')"
                      >
                        비교견적 신청하기
                      </el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </template>
        </div>

        <div class="sub">
          <i class="material-icons" style="width: 20px; font-size: 16px">info_outlined</i>
          보험료는 가입 시점에 보험 나이 및 병력, 보험사의 인수정책에 따라 달라질 수 있습니다.
        </div>
      </div>

      <div class="top">
        <div class="table-pagination" :style="procDone ? 'display: inline-flex' : 'display: none'">
          <span>{{ companies.length }}개 보험사</span>
          <div :style="isMobile ? 'display: inline-flex' : 'display: none'">
            <button
              class="pagination-button"
              v-for="(item, idx) in companies"
              :key="idx"
              :class="active === idx ? 'active' : ''"
              @click="movePagination(idx)"
            />
          </div>
        </div>

        <div class="unit" :style="procDone && !isMobile ? 'display: inline-flex' : 'display: none'">
          <span>단위: 만원</span>
        </div>

        <div class="prev-next-btn" :style="procDone && isMobile ? 'display: inline-flex' : 'display: none'">
          <el-button
            size="mini"
            :disabled="active === 0"
            @click="movePagination(active - 1)"
          >
            이전
          </el-button>
          <el-button
            size="mini"
            :disabled="(active + 1) === companies.length"
            @click="movePagination(active + 1)"
          >
            다음
          </el-button>
        </div>
      </div>
      <!-- 보험료 테이블 -->
      <div class="premium-table" v-if="procDone">
        <!-- 좌측 항목 시작 -->
        <div class="column">
          <div class="pt-cell h-58">
            <span class="bolder">보험사</span>
          </div>
          <div
            class="pt-cell"
            v-for="(item, idx) in lifeEstimateCompare.항목정보.filter(e => (e.보장항목 == '일반항목' || e.보장항목 === '합계항목') && e.사용 == '사용' && 하단고정항목.indexOf(e.항목명) == -1)"
            :key="idx + 'o1'"
            :class="{'line-cover': (item.보장항목 == '일반항목' || item.보장항목 === '합계항목') && item.사용 == '사용', 'blue': highlight항목.indexOf(item.항목명) != -1}"
          >
            <span
              class="bolder"
              :class="{'color-black': highlight항목.indexOf(item.항목명) !== -1}"
            >{{item.항목명}}</span>
          </div>
          
          <div class="line-cover blue pt-cell"><span class="bolder color-black">보험금</span></div>
          <template v-for="(item, idx) in lifeEstimateCompare.항목정보.filter(e => e.보장항목 == '보장항목' && e.사용 == '사용')">
            <template v-if="useKeys.indexOf(item.항목명) !== -1">
              <div class="pt-cell" :key="idx + 'o2'">
                <span>
                  <el-tooltip placement="right" :disabled="!item.설명">
                    <div slot="content" style="white-space: break-spaces;">{{item.설명}}</div>
                    <div class="cst-cell el-cst-hi26">
                      {{item.항목명}}
                      <i class="material-icons info-icon" v-if="item.설명">info</i>
                    </div>
                  </el-tooltip>
                </span>
              </div>
            </template>
          </template>

          <div class="pt-cell" v-for="(item, idx) in lifeEstimateCompare.항목정보.filter(e => (e.보장항목 == '일반항목' || e.보장항목 === '합계항목') && e.사용 == '사용' && 하단고정항목.indexOf(e.항목명) != -1)" :key="idx + 'o3'">
            <span class="bolder color-black">{{item.항목명}}</span>
          </div>
        </div>

        <!-- 보험사 시작 -->
        <div
          class="column compare-company"
          v-for="보험사 in companies"
          :key="보험사"
          :ref="`compare-${보험사}`"
        >
          <template v-if="lifeEstimateCompare['보험사항목정보'][보험사]">
            <div class="pt-cell text-center h-58">
              <img :src="lifeEstimateCompare['보험사정보'][보험사].이미지" style="display: inline-block; width: auto; max-height: 58px; vertical-align: middle; margin-right: 5px;"/>
              <!-- <span class="bolder">{{보험사}}</span> -->
            </div>

            <div v-for="(항목, idx) in lifeEstimateCompare.항목정보.filter(e => (e.보장항목 == '일반항목' || e.보장항목 === '합계항목') && e.사용 == '사용' && 하단고정항목.indexOf(e.항목명) == -1)" :key="idx + 'b1'" class="pt-cell" :class="{'line-cover': (항목.보장항목 == '일반항목' || 항목.보장항목 === '합계항목') && 항목.사용 == '사용', 'blue': highlight항목.indexOf(항목.항목명) != -1}">
              <template v-if="(항목.보장항목 == '일반항목' || 항목.보장항목 === '합계항목') && 항목.사용 == '사용'">
                <template v-if="lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명] && lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명].데이터1.indexOf('http') == -1">
                  <div class="text-center">
                    <span class="bolder color-black">
                      {{lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명].데이터1 | number}}
                      {{ !isNaN(lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명].데이터1) ? '원' : ''}}
                    </span>
                  </div>
                </template>
              </template>
            </div>

            <template v-if="hip">
              <div class="line-cover blue">
                <div class="text-center">
                  <span class="pt-cell color-blue fs-14 f-500">보험금</span>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="line-cover blue">
                <div class="col-sep">
                  <div class="row bolder pt-cell text-center"><span>보험금</span></div>
                  <div class="row color-blue bolder pt-cell text-center"><span>보험료</span></div>
                </div>
              </div>
            </template>

            <template v-for="(항목, idx) in lifeEstimateCompare.항목정보.filter(e => e.보장항목 == '보장항목' && e.사용 == '사용')">
              <template v-if="항목.보장항목 == '보장항목' && 항목.사용 == '사용'">
                <template v-if="useKeys.indexOf(항목.항목명) !== -1">
                  <template v-if="hip">
                    <div
                      class="pt-cell right"
                      v-if="!ca && !dc"
                      @click="openInsuMoneyCalcDialog(보험사, lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명])"
                      :key="idx + 'b1'"
                    >
                      <span>
                        {{lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명] ? 
                        number(lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명].데이터4)
                        : 0}}
                      </span>
                    </div>

                    <div
                      class="col-sep"
                      v-else
                      @click="openInsuMoneyCalcDialog(보험사, lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명])"
                      :key="idx + 'b1_1'"
                    >
                      <div class="row pt-cell text-center">
                        <span class="color-black f-400">
                        {{lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명] ?
                        number(lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명].데이터4)
                        : 0}}
                        </span>
                      </div>
                      <div class="row right color-blue pt-cell disable">
                        <template v-if="lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명]">
                          <span v-if="lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명].isCalc">
                            {{lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명] ?
                              number(lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명].데이터4)
                            : 0}}
                          </span>
                        </template>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div
                      class="col-sep"
                      v-if="dc"
                      @click="openInsuMoneyCalcDialog(보험사, lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명])"
                      :key="idx + 'b2'"
                    >
                      <div class="row pt-cell right">
                        <span>
                        {{lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명] ?
                        number(lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명].데이터4)
                        : 0}}
                        </span>
                      </div>
                      <div class="row color-blue pt-cell right">
                        <span>
                          {{lifeEstimateCompare['보험사보험료'][보험사][항목.항목명] ? 
                          number(lifeEstimateCompare['보험사보험료'][보험사][항목.항목명].데이터1) 
                          : 0}}
                        </span>
                      </div>
                    </div>
                    <div class="col-sep" v-else :key="idx + 'b2_1'">
                      <div class="row pt-cell right">
                        <span>
                        {{lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명] ?
                        number(lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명].데이터4)
                        : 0}}
                        </span>
                      </div>
                      <div class="row color-blue pt-cell right">
                        <span>
                          {{lifeEstimateCompare['보험사보험료'][보험사][항목.항목명] ? 
                          number(lifeEstimateCompare['보험사보험료'][보험사][항목.항목명].데이터1) 
                          : 0}}
                        </span>
                      </div>
                    </div>
                    <!--<div class="col-sep" v-else-if="ca">
                      <div class="row pt-cell">
                        <span>
                        {{lifeEstimateCompare['보험사항목정보'][보험사][항목.항목명] ?
                        number(lifeEstimateCompare['보험사항목정보'][보험사][항목.항목명].데이터4)
                        : 0}}
                        </span>
                      </div>
                      <div class="row color-blue pt-cell">
                        <span>
                          {{lifeEstimateCompare['보험사보험료'][보험사][항목.항목명] ? 
                          number(lifeEstimateCompare['보험사보험료'][보험사][항목.항목명].데이터1) 
                          : 0}}
                        </span>
                      </div>
                    </div>-->
                  </template>
                </template>
              </template>
            </template>
            <div v-for="(항목, idx) in lifeEstimateCompare.항목정보.filter(e => e.보장항목 == '일반항목' && e.사용 == '사용' && 하단고정항목.indexOf(e.항목명) != -1)" :key="idx + 'b3'">
              <div class="pt-cell" style="text-align: center;">
                <el-link :href="lifeEstimateCompare['보험사항목정보'][보험사][firstKey][항목.항목명].데이터1" target="_blank" type="primary" size="mini">보기</el-link>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- 하단 -->
    <div class="footer" v-if="procDone" :class="isForm ? '' : 'pa-25'">
      <div class="title" v-if="selectedCompany.length <= 2">
        <span class="bold color-blue">선호하는 보험사</span>를 선택해주세요!
      </div>
      <div class="title" v-else-if="selectedCompany.length > 2">
        <span class="bold color-blue">선호 보험사</span>는 2개 까지만 체크 가능합니다!
      </div>

      <div class="sub">
        <span>최대 2개 선택 가능</span>
      </div>

      <div class="section company">
        <ul class="company-list">
          <li v-for="보험사 in companies" :key="보험사" @click="selectCompany(보험사)">
            <template v-if="selectedCompany.indexOf(보험사) !== -1">
              <el-checkbox :value="selectedCompany.indexOf(보험사) !== -1"></el-checkbox>
              <img :src="$store.state.allianceImgList.find(o => o.name == 보험사) ? $store.state.allianceImgList.find(o => o.name == 보험사).value : null" />
            </template>

            <template v-else>
              <img :src="$store.state.allianceImgList.find(o => o.name == 보험사) ? `${$store.state.allianceImgList.find(o => o.name == 보험사).value.split('.png')[0]}_disabled.png` : null" />
            </template>
          </li>
        </ul>
      </div>
      <div class="section" :class="isForm ? 'blue' : ''">
        <template v-if="!isForm">
          <div class="checkMyInsurance" style="margin-bottom: 1rem">
            <el-checkbox v-model="checkmyinsure">
              내 보험 점검 신청하기 <span class="grey-font">(선택)</span>
              <el-popover
                placement="top"
                width="800"
                trigger="click"
              >
                <div>
                  고객님께서 현재 가입한 모든 보험 및 보장금액 내용을 한국신용정보원과 보험협회로 부터 조회하여 이메일 및 카톡으로 보내드립니다.
                  결과 서류를 보시면 불필요한 보험을 정리하거나 리모델링을 종합적으로 판단하고 선택하실 수 있습니다.
                </div>

                <span slot="reference">
                  <!-- <img style="display: inline-block; margin-left: 0.2rem; max-width: 1.2rem; line-height: 3.5rem; vertical-align: middle;" :src="statusHelp ? '../static/cancel_blue.png' : '../static/help_gray.png'"/> -->
                  <i class="material-icons info-icon" @click="e => { e.preventDefault(); }">info</i>
                </span>
              </el-popover>
            </el-checkbox>
          </div>

          <div class="button reservation" :class="{disabled: selectedCompany.length > 2}" v-if="selectedCompany.length == 0" @click="reservation">추천 보험사로 상담 <img :src="'../static/Shape.png'" /></div>
          <div class="button reservation" :class="{disabled: selectedCompany.length > 2}" v-if="selectedCompany.length > 0" @click="reservation">선호 보험사로 상담 <img :src="'../static/Shape.png'" /></div>
        </template>

        <template v-else>
          <div class="checkMyInsurance" v-if="!isMobile">
            <el-checkbox v-model="checkmyinsure">
              내 보험 점검 신청하기 <span class="grey-font">(선택)</span>
              <el-popover
                placement="top"
                width="800"
                trigger="click"
              >
                <div>
                  고객님께서 현재 가입한 모든 보험 및 보장금액 내용을 한국신용정보원과 보험협회로 부터 조회하여 이메일 및 카톡으로 보내드립니다.
                  결과 서류를 보시면 불필요한 보험을 정리하거나 리모델링을 종합적으로 판단하고 선택하실 수 있습니다.
                </div>

                <span slot="reference">
                  <!-- <img style="display: inline-block; margin-left: 0.2rem; max-width: 1.2rem; line-height: 3.5rem; vertical-align: middle;" :src="statusHelp ? '../static/cancel_blue.png' : '../static/help_gray.png'"/> -->
                  <i class="material-icons info-icon" @click="e => { e.preventDefault(); }">info</i>
                </span>
              </el-popover>
            </el-checkbox>
          </div>

          <div class="round">
            <el-form
              :model="formData"
              :rules="rules"
              ref="ruleFormBottom"
            >
              <el-row :gutter="20">
                <el-col :md="5" :sm="12" :xs="12" class="form-input">
                  <el-form-item label="이름" prop="name" class="first-input">
                    <el-input placeholder="이름을 입력해주세요." v-model="formData.name" />
                  </el-form-item>
                </el-col>
  
                <el-col :md="5" :sm="12" :xs="12" class="form-input">
                  <el-form-item label="생년월일" prop="birth">
                    <el-date-picker
                      v-model="formData.birth"
                      value-format="yyyy-MM-dd"
                      ref="birthDateBottom"
                      class="birth-input"
                      @focus="focusBirth('birthDateBottom')"
                      @change="changeBirth"
                    />
                  </el-form-item>
                </el-col>
  
                <el-col :md="4" :sm="12" :xs="12" class="form-input">
                  <el-form-item label="성별" prop="gender" class="gender">
                    <el-radio v-model="formData.gender" label="남성">남성</el-radio>
                    <el-radio v-model="formData.gender" label="여성">여성</el-radio>
                  </el-form-item>
                </el-col>
  
                <el-col :md="5" :sm="12" :xs="12" class="form-input">
                  <el-form-item label="연락처" prop="phoneNumber">
                    <el-input placeholder="연락처를 입력해주세요" v-model="formData.phoneNumber" />
                  </el-form-item>
                </el-col>

                <el-col :sm="24" :xs="24" v-if="isMobile">
                  <el-form-item label="">
                    <div class="checkMyInsurance bg-white">
                      <el-checkbox v-model="checkmyinsure">
                        내 보험 점검 신청하기 <span class="grey-font">(선택)</span>
                        <el-popover
                          placement="top"
                          width="800"
                          trigger="click"
                        >
                          <div>
                            고객님께서 현재 가입한 모든 보험 및 보장금액 내용을 한국신용정보원과 보험협회로 부터 조회하여 이메일 및 카톡으로 보내드립니다.
                            결과 서류를 보시면 불필요한 보험을 정리하거나 리모델링을 종합적으로 판단하고 선택하실 수 있습니다.
                          </div>
  
                          <span slot="reference">
                            <!-- <img style="display: inline-block; margin-left: 0.2rem; max-width: 1.2rem; line-height: 3.5rem; vertical-align: middle;" :src="statusHelp ? '../static/cancel_blue.png' : '../static/help_gray.png'"/> -->
                            <i class="material-icons info-icon" @click="e => { e.preventDefault(); }">info</i>
                          </span>
                        </el-popover>
                      </el-checkbox>
                    </div>
                  </el-form-item>
                </el-col>
  
                <el-col :md="5" :sm="24" :xs="24">
                  <el-form-item label="">
                    <el-button
                      type="primary"
                      class="submit-btn"
                      round
                      @click="validForm('ruleFormBottom')"
                    >
                      비교견적 신청하기
                    </el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </template>
      </div>
    </div>
    <el-dialog id="insu_calc_dlg" :title="insu_money_calc_dlg.title" :visible.sync="insu_money_calc_dlg.visible" width="500px" append-to-body>
      <el-row>
        <el-col :span="12">
          <div class="flex">
            <div class="el-cst-label el-cst-hi26 aligned center highlight type-static-100">보험금</div>
            <div style="margin-left: auto;">
              <el-input-number class="type-static-155" 
                v-model="insu_money_calc_dlg.value" 
                :min="insu_money_calc_dlg.min" 
                :max="insu_money_calc_dlg.max" 
                :step="insu_money_calc_dlg.step"
                @change="InsuMoneyCalcDialogValueChangeHandler"></el-input-number>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="flex">
            <div class="el-cst-label el-cst-hi26 aligned center highlight type-static-100">보험료</div>
            <div class="el-cst-label el-cst-hi26 aligned center" style="width: 100%;">{{insu_money_calc_dlg.value2 | number}}</div>
          </div>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-row class="flex">
          <span class="el-cst-label el-cst-hi26 red">{{insu_money_calc_dlg.label}}</span>
          <el-button class="el-cst-hi28 simple type-static-125" type="primary" style="margin-left: auto;" @click="saveInsuMoneyCalcDialog">저장</el-button>
        </el-row>
      </el-row>
    </el-dialog>

    <div class="spinner-area" ref="spinner">
      <div class="loadingio-spinner-ellipsis-v3ytqcu5wu">
        <div class="sk-text" :class="isMobile ? 'color-black' : 'color-white'">보험료 계산 중</div>
        <div class="ldio-tvytf13gwci">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Row, Col, Divider, InputNumber, Checkbox, Tooltip, Link, Button } from 'element-ui'
import moment from "moment";
import { modalItems } from "@/router/routes";
import lifePremium from "@/mixin/lifePremium"

export default {
  mixins: [ lifePremium ],
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Divider.name]: Divider,
    [InputNumber.name]: InputNumber,
    [Checkbox.name]: Checkbox,
    [Tooltip.name]: Tooltip,
    [Link.name]: Link,
    [Button.name]: Button,
  },
  data() {
    const emptyInput = (rule, value, cb) => {
      if (value === '' || !value) {
        cb(new Error(rule.message));
      }

      cb();
    }

    return {
      id: '2841804',
      hip: false, // [query 스트링] 보험료 숨김 여부
      ca: false, // [query 스트링] 쿼리스트링 변수를 통한 보험료 계산 여부
      dc: true, // [query 스트링] 보험금 수정가능 여부
      highlight항목: [
        '적립보험료', '보장보험료', '납입보험료(월)'
      ],
      하단고정항목: [
        '상품요약서', '보험약관'
      ],
      lifeEstimateCompare: {
        시트: [],
        보험정보: [],
        보험사정보: {},
        항목정보: [],
        보험사항목정보: {},
        보험사보험료: {},
      },
      lifeEstimateCompareForm: {
        시트url: '',
        보험종목: '',
        나이: 0,
        직업: '1',
        성별: '남자',
      },
      insu_money_calc_dlg: {
        currentItem: null,
        title: '',
        visible: false,
        min: 0,
        max: 0,
        step: 0,
        value: 0,
        value2: 0,
        ratio: 0,
        label: '',
      },
      selectedCompany: [],
      customer: {},
      estimateData: {},
      conditionData: {},
      procDone: false,
      active: 0,
      companies: [],
      firstKey: '운전자-기본',
      startX: 0,
      startY: 0,
      isMobile: this.$store.state.config.isTouchDevice,
      useKeys: [],
      receiver: 'ltw@insunetfc.com',
      formData: {
        name: '',
        phoneNumber: '',
        birth: '1980-01-01',
        gender: '남성',
      },
      rules: {
        name: [{ validator: emptyInput, message: '이름을 입력해주세요', trigger: 'blur' }],
        phoneNumber: [{ validator: emptyInput, message: '연락처를 입력해주세요', trigger: 'blur' }],
        birth: [{ validator: emptyInput, message: '생년월일을 입력해주세요', trigger: 'change' }],
        gender: [{ validator: emptyInput, message: '성별을 선택해주세요', trigger: 'change' }],
      },
      isForm: true,
      checkmyinsure: false,
      reservation_inflow_referer_source: '',
    }
  },
  async mounted() {
    if(this.$route.query.id) this.id = this.$route.query.id
    this.hip = this.$route.query.hip !== undefined ? true : false
    this.ca = this.$route.query.ca !== undefined ? true : false
    this.dc = this.$route.query.dc !== undefined ? true : false

    if (this.$route.query.ci) {
      this.getCustomer(this.$route.query.ci);
    }

    if (this.$route.query.refin) {
      this.reservation_inflow_referer_source = this.$route.query.refin;
    }

    this.formData = {
      name: this.$route.query.name || '',
      birth: this.$route.query.birth || '1980-01-01',
      gender: (this.$route.query.sx === '남자' ? '남성' : '여성') || '남성',
      phoneNumber: this.$route.query.phoneNumber || ''
    }

    if (this.$route.query.name) {
      this.isForm = false;
    }

    if(!this.ca) {
      this.init()
    }else{
      if(this.$route.query.ins === undefined) {this.close();return;}
      if(this.$route.query.ag === undefined) {this.close();return;}
      if(this.$route.query.jb === undefined) {this.close();return;}
      if(this.$route.query.sx === undefined) {this.close();return;}
      if(this.$route.query.tb === undefined) {this.close();return;}

      if (this.$store.state.customer.profile._id) {
        this.getCustomer(this.$store.state.customer.profile._id);
      }

      this.lifeEstimateCompareForm.보험종목 = this.$route.query.ins // '운전자'
      this.lifeEstimateCompareForm.나이 = this.$route.query.ag // 29
      this.lifeEstimateCompareForm.직업 = this.$route.query.jb // '1'
      this.lifeEstimateCompareForm.성별 = this.$route.query.sx // '남자'

      this.$store.state.pagename = this.lifeEstimateCompareForm.보험종목.split('-')[0] + '보험';

      this.changeSpreadSheet(this.$route.query.tb) // "15PVCKlLLrrLfxUKJ_lnpS7RspynmY6H28TBu955N5ic"
      await this.initInsuPri()
    }

    window.addEventListener('resize', this.resizeEventHandler);
    window.addEventListener('touchstart', this.touchStartEventHandler);
    window.addEventListener('touchend', this.touchEndEventHandler);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeEventHandler);
    window.removeEventListener('touchstart', this.touchStartEventHandler);
    window.removeEventListener('touchend', this.touchEndEventHandler);
  },
  watch: {
    procDone(value) {
      if (value) {
        this.doneSpinner();
        this.uniqueInsuranceDetailInfo();
      }
    },
    'formData.phoneNumber'(value) {
      let phoneNumber = value;

      if (value.length > 13) {
        phoneNumber = phoneNumber.substr(0, 13);
      } else {
        phoneNumber = value.replace(/[^0-9]/g, '').replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, '$1-$2-$3').replace("--", "-");
      }

      this.formData.phoneNumber = phoneNumber;
    },
  },
  methods: {
    number(value) {
      if( value ){
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }else{
        return 0;
      }
    },
    init() {
      this.axios.get(`${this.$store.state.config.hostName}/v1/crm/estimate.condition/${this.id}`).then(res => {
        let { data, error } = res.data
        if (error) {
          return
        }
        this.getEstimate(data.estimate_id)
        this.conditionData = data
        var tmp_extra = JSON.parse(data.estimate_condition_extra ? data.estimate_condition_extra : '{}')
        this.conditionData.extra = tmp_extra
        if(tmp_extra['보험료정보']) {
          const tmpObjInfo = tmp_extra.보험료정보.data.보험사항목정보;
          this.lifeEstimateCompare = tmp_extra.보험료정보.data
          // 2022-05-16 상품요약서, 보험약관 뺼필요 없음 
          /*this.lifeEstimateCompare.항목정보 = this.lifeEstimateCompare.항목정보.filter(e => {
            return e.항목명 != '상품요약서' &&  e.항목명 != '보험약관'
          })*/

          Object.keys(tmpObjInfo).map((key, index) => {
            let tmpObj = tmpObjInfo[key];

            if (!tmpObj['운전자-기본']) {
              tmpObj = {
                '운전자-기본': tmpObj
              }
            }

            if (index === 0) {
              this.lifeEstimateCompare['보험사항목정보'][key] = {};
            }
            this.lifeEstimateCompare['보험사항목정보'][key] = tmpObj;

            this.companies.push(key);
          })
          this.procDone = true;
        }
      })
      .catch(e => {
      })
    },
    submitCondition() {
      this.conditionData.estimate_condition_extra = JSON.stringify(this.conditionData.extra);
      this.axios.put(`${this.$store.state.config.hostName}/v1/crm/estimate.condition/edit/${this.id}`, this.conditionData).then(res => {
        let { data, error } = res.data
        if (error) {
          return
        }
      })
      .catch(e => {
      })
    },
    getEstimate(id) {
      this.axios.get(`${this.$store.state.config.hostName}/v1/crm/estimate/${id}`).then(res => {
        let { data, error } = res.data
        if (error) {
          return
        }
        this.getCustomer(data.customerId)
        this.estimateData = data
        this.$store.state.pagename = `${data.estimate_type}보험 견적서`;
        this.getReciever();
        this.sendHangout({ ...data, insuranceType: data.estimate_type });
      })
      .catch(e => {
      })
    },
    getCustomer(id) {
      this.axios.get(`${this.$store.state.config.hostName}/v1/crm/customer/${id}`).then(res => {
        let { data, error } = res.data
        if (error) {
          return
        }
        this.customer = data
      })
      .catch(e => {
      })
    },
    close(){
      const isExistModal = Object.keys(modalItems).filter(item => item === this.$route.name);

      if (this.isMobile) {
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        const name = this.$route.name === 'CompareEstimate' ? this.$route.name : 'CompareEstimate'
        let tab = this.$route.query.ins.split('-')[0];
        tab = tab.indexOf('보험') === -1 ?  `${tab}보험` : tab;
        
        this.$router.replace({ name, query: { tab }});
      }

      if (isExistModal.length) {
        if (document.referrer) {
          this.$router.push({ name: "Home" });
        }

        history.back();
      } else {
        this.$store.commit( "elementModal/CLEAR_ITEMS" );
        var tab = this.$route.query.tab;
        this.$router.replace({ query: { tab : tab}})
      }
    },
    selectCompany(company) {
      let idx = this.selectedCompany.indexOf(company);
      if(idx === -1) {
        if (this.selectedCompany.length < 2) {
          this.selectedCompany.push(company) 
        }
      }else{
        this.selectedCompany.splice(idx, 1)
      }
    },
    getBirthNumber() {
      let birth = this.formData.birth;
      let sx = this.formData.gender;

      if (this.$route.query.birth && this.$route.query.sx) {
        birth = this.$route.query.birth;
        sx = this.$route.query.sx;
      }

      const year = birth.split('-')[0] * 1;
      const _birth = birth.split('-').join('').slice(2);
      let gender = {
        '남자': 1,
        '남성': 1,
        '여자': 2,
        '여성': 2
      }[sx];

      if (year > 1999) {
        gender = gender + 2;
      }

      return _birth + gender;
    },
    async validForm(ref) {
      this.$refs[ref].validate((valid) => {
        this.formData.submit = valid;

        if (!valid) {
          return false;
        }

        this.reservation();        
      })

    },
    async reservation() {
      this._nasa();
      
      if (!this.customer._id) {
        this.reservationNoneCustomer();
        return;
      }

      // 다음 평일 09시 예약으로 고정
      let mmD
      let url = 'reservation/createItemsForLifePremium';
      const { date, time } = this.$getDefaultConsultTime();
      let queryItems = this.$route.query;
      const getReservationMemoAndInflow = this.getReservationMemoAndReservationInflow();
      const reservation_inflow = getReservationMemoAndInflow.reservation_inflow ? getReservationMemoAndInflow.reservation_inflow : '홈페이지';

      let param = {
        adminj: 35,
        admin: this.estimateData.admin_id,
        customer_id: this.estimateData.customerId,
        reservation_name: this.estimateData.customerName,
        reservation_contract: this.customer.customer_phone_number,
        reservation_inflow,
        reservation_date_request: date.split('.').join('-') + ' ' + time + ':00',
        ip: '',
        checkmyinsure: this.checkmyinsure
      }
      let _memo = getReservationMemoAndInflow.reservation_memo;

      if (date === '') {
        param.reservation_date_request = moment(new Date()).format('YYYY-MM-DD') + ' ' + time + ':00';
      }

      if (moment().day() === 5) { // friday, show monday
        // set to monday
        mmD = moment().weekday(8)
      } else if (moment().day() === 6) { // saturday, show monday
        // set to monday
        mmD = moment().weekday(8)
      }else { // other days, show next day
        mmD = moment().add(1, 'days')
      }

      var dcd_ref = ""
      try {
        dcd_ref = decodeURI(window.document.referrer)
      } catch(e) {

      }
      
      if (!this.ca) {
        _memo = "[전화상담예약] " + this.conditionData.extra.condition.설계요청내용.보험종목 + " " + this.estimateData.customerName + "님께서 상담예약하였습니다. 시간에 맞춰 연락하십시오. "
        _memo = _memo + "\n상담내용 : 선호보험사(" + (this.selectedCompany.length > 0 ? this.selectedCompany.join(' , ') : '없음') + ") "

        if (this.checkmyinsure) {
          _memo = `${_memo}\n[보험점검]`;
        }
  
        param = {
          ...param,
          reservation_memo: _memo,
          referrer: dcd_ref,
          reservation_type: this.conditionData.extra.condition.설계요청내용.보험종목
        }
      } else {
        let customer_id = '';
        let customer_birth = '';
        let reservation_name = this.$route.query.name ? this.$route.query.name : '';
        let reservation_contract = this.$route.query.phoneNumber ? this.$route.query.phoneNumber.split('-').join('') : '';

        if (this.$route.query.ci) {
          const {
            _id,
            customer_social_number,
            customer_phone_number,
            customer_name
          } = this.customer;
          customer_id = _id;
          customer_birth = customer_social_number.substring(0, 7);
          reservation_contract = customer_phone_number;
          reservation_name = customer_name;
        } else {
          customer_id = this.$store.state.customer.profile._id;
          customer_birth = this.getBirthNumber();
        }

        let reservation_memo = getReservationMemoAndInflow.reservation_memo;
        url = 'reservation/createItemsForLifePremiumWeb';


        if (this.checkmyinsure) {
          reservation_memo = `${reservation_memo}\n[보험점검]`;
        }

        param = {
          ...param,
          admin: 35,
          customer_id: customer_id ? customer_id : 0,
          customer_birth,
          reservation_contract,
          reservation_type: this.$route.query.ins.split('-')[0],
          reservation_inflow,
          reservation_name,
          reservation_memo,
          referrer: dcd_ref
        }
      }


      if (this.reservation_inflow_referer_source !== '') {
        param.reservation_inflow_referer_source = this.reservation_inflow_referer_source;
      }

      this.$store.dispatch(url, param).then(res => {
        const { error } = res.data;

        if (error) {
          this.$store.commit( "elementSnackbar/SET_ITEM", { message: error, status: "false" } );
          return;
        }

        this.close();
        this.$store.commit("elementModal/SET_ITEM", { elementId: "globalLifeEstimateResult", query: queryItems });
      })
    },
    openInsuMoneyCalcDialog(보험사, 보험사항목정보) {
      if (!this.dc || 보험사항목정보 === undefined) {
        return;
      }

      let 보험료정보 = this.lifeEstimateCompare['보험사보험료'][보험사][보험사항목정보.항목명]
      this.insu_money_calc_dlg.title = 보험사 + ' - ' + 보험료정보.보험사항목명
      
      this.insu_money_calc_dlg.min = Number(보험사항목정보.데이터1)
      this.insu_money_calc_dlg.max = Number(보험사항목정보.데이터2)
      this.insu_money_calc_dlg.step = Number(보험사항목정보.데이터3)
      this.insu_money_calc_dlg.value = Number(보험사항목정보.데이터4)
      this.insu_money_calc_dlg.label = 보험사항목정보.데이터5
      this.insu_money_calc_dlg.value2 = Number(보험료정보.데이터1)

      this.insu_money_calc_dlg.currentItem = {
        보험사: 보험사,
        보험료정보: 보험료정보,
        보험사항목정보: 보험사항목정보,
      }
      
      보험사항목정보.isCalc = true;

      this.insu_money_calc_dlg.ratio = Number(보험료정보.기준보험료) / Number(보험사항목정보.기준보험금)
      this.insu_money_calc_dlg.visible = true
    },
    InsuMoneyCalcDialogValueChangeHandler(currentValue, oldValue) {
      this.insu_money_calc_dlg.value2 = Math.floor(currentValue * this.insu_money_calc_dlg.ratio)
    },
    saveInsuMoneyCalcDialog() {
      this.insu_money_calc_dlg.visible = false
      this.insu_money_calc_dlg.currentItem.보험료정보.데이터1 = this.insu_money_calc_dlg.value2
      this.insu_money_calc_dlg.currentItem.보험사항목정보.데이터4 = this.insu_money_calc_dlg.value
      this.calcExtraInsurancePri(this.insu_money_calc_dlg.currentItem.보험사)
      
      if(this.ca || !this.id) this.submitCondition()
    },
    calcExtraInsurancePri(보험사) {
      let 기본보험료item = this.lifeEstimateCompare.보험사항목정보[보험사][this.firstKey]['기본보험료']
      let 기본보험료 = Number(기본보험료item.데이터1)
      let 보장보험료 = Object.values(this.lifeEstimateCompare.보험사보험료[보험사]).map(e => Number(e.데이터1 || 0)).reduce((previousValue, currentValue) => {
        return (previousValue || 0) + (currentValue || 0)
      }, 0) || 0;

      if (!isFinite(보장보험료)) {
        보장보험료 = 0;
      }

      let 적립보험료 = 0
      if(기본보험료 > 보장보험료) {
        적립보험료 = 기본보험료 - 보장보험료
      } else if(기본보험료 == 보장보험료) {
        적립보험료 = 0
      }else{
        적립보험료 = (Math.ceil(보장보험료 / 10) * 10 - 보장보험료)
      }
      this.lifeEstimateCompare.보험사항목정보[보험사][this.firstKey]['보장보험료'].데이터1 = 보장보험료.toString()
      this.lifeEstimateCompare.보험사항목정보[보험사][this.firstKey]['적립보험료'].데이터1 = 적립보험료.toString()
      this.lifeEstimateCompare.보험사항목정보[보험사][this.firstKey]['납입보험료(월)'].데이터1 = (보장보험료 + 적립보험료).toString();
    },
    /**/
    async initInsuPri() {
      this.procDone = false
      
      let 보험종목 = this.lifeEstimateCompareForm.보험종목

      this.lifeEstimateCompare = {
        시트: [],
        보험정보: [],
        보험사정보: {},
        항목정보: [],
        보험사항목정보: {},
        보험사보험료: {},
      }

      this.startSpinner();
      await this.isHideHeader();
      await this.getSpreadInsuranceInfo(보험종목)
      await this.calcInsuPriProc(보험종목)
      // 2022-05-16 상품요약서, 보험약관 뺼필요 없음 
      /*this.lifeEstimateCompare.항목정보 = this.lifeEstimateCompare.항목정보.filter(e => {
        return e.항목명 != '상품요약서' &&  e.항목명 != '보험약관'
      })*/
      this.procDone = true
      this.companies = Object.keys(this.lifeEstimateCompare['보험사보험료']);
      fetch('https://api64.ipify.org?format=json')
      .then(x => x.json())
      .then(({ ip }) => {
        this.sendHangout({ customerName: ip, insuranceType: 보험종목.split('-')[0] });
      });
    },
    async calcInsuPriProc(보험종목) {
      const insureType = {
        '운전자-기본': '운전자'
      }[this.lifeEstimateCompareForm.보험종목] || this.lifeEstimateCompareForm.보험종목;
      const promises = []
      for(let i = 0; i < this.lifeEstimateCompare.보험정보.length; i++) {
        promises.push((async () => {
          let company = this.lifeEstimateCompare.보험정보[i]
          await this.getSpreadCompanyInfo(company)
          await this.getSpreadCompCategoryDetailInfo(보험종목, company, this.lifeEstimateCompareForm.성별, this.lifeEstimateCompareForm.직업)
          await this.getSpreadCompInsurancePri(insureType, company, this.lifeEstimateCompareForm.성별, this.lifeEstimateCompareForm.직업, this.lifeEstimateCompareForm.나이.toString())
        })())
      }
      await Promise.all(promises);
      await this.getSpreadInsuranceDetailInfo(보험종목);
    },
    calcInsurancePri(보험사, 항목명) {
      // if (this.lifeEstimateCompare.보험사항목정보[보험사][this.firstKey][항목명]) {
        let cvRatio = Number(this.lifeEstimateCompare.보험사항목정보[보험사][this.firstKey][항목명].기준보험금) / Number(this.lifeEstimateCompare.보험사보험료[보험사][항목명].보험료기준)
        this.lifeEstimateCompare.보험사보험료[보험사][항목명].데이터1 = this.lifeEstimateCompare.보험사보험료[보험사][항목명].기준보험료
          = Math.floor(this.lifeEstimateCompare.보험사보험료[보험사][항목명].데이터1 *  cvRatio)
      // }
      
      /*let ratio = Number(this.lifeEstimateCompare.보험사보험료[보험사][항목명].기준보험료) / Number(this.lifeEstimateCompare.보험사항목정보[보험사][항목명].기준보험금)
      this.lifeEstimateCompare.보험사보험료[보험사][항목명].데이터1 = Math.floor(this.lifeEstimateCompare.보험사항목정보[보험사][항목명].데이터4 * ratio)*/
    },
    createExtraInsurancePriItem(보험종목, 보험사, 성별, 등급) {
      this.lifeEstimateCompare.보험사항목정보[보험사][this.firstKey]['보장보험료'] = {
        보험종목: 보험종목,
        성별: 성별,
        등급: 등급,
        항목명: '보장보험료',
        데이터1: null,
        데이터2: null,
        데이터3: null,
        데이터4: null,
        데이터5: null,
      }
      this.lifeEstimateCompare.보험사항목정보[보험사][this.firstKey]['적립보험료'] = {
        보험종목: 보험종목,
        성별: 성별,
        등급: 등급,
        항목명: '적립보험료',
        데이터1: null,
        데이터2: null,
        데이터3: null,
        데이터4: null,
        데이터5: null,
      }
      this.lifeEstimateCompare.보험사항목정보[보험사][this.firstKey]['납입보험료(월)'] = {
        보험종목: 보험종목,
        성별: 성별,
        등급: 등급,
        항목명: '납입보험료(월)',
        데이터1: null,
        데이터2: null,
        데이터3: null,
        데이터4: null,
        데이터5: null,
      }
    },
    resizeEventHandler() {
      const { userAgent } = window.navigator;
      const tables = document.querySelectorAll('.compare-company');

      this.isMobile = /iPhone|iPad|iPod|Android/i.test(userAgent);

      document.getElementById('site-header').style.display = this.isMobile ? 'none' : 'block';
      document.getElementById('site-container').style.paddingTop = this.isMobile ? '0px' : '6.14rem';

      if (!this.isMobile) {
        for (let i = 0; i < tables.length; i++) {
          tables[i].style.display = 'block';
        }
      } else {
        this.movePagination(this.active);
      }
    },
    movePagination(idx = 0) {
      const paginations = document.querySelectorAll('.pagination-button');
      const tables = document.querySelectorAll('.compare-company');
      this.active = idx;

      for (let i = 0; i < paginations.length; i++) {
        paginations[i].classList.remove('active');
        tables[i].style.display = 'none';
      }

      paginations[idx].classList.add('active');
      tables[idx].style.display = 'block';
    },
    startSpinner() {
      this.$refs.spinner.style.display = 'block';
    },
    doneSpinner() {
      this.$refs.spinner.style.display = 'none';
    },
    isHideHeader() {
      const { userAgent } = window.navigator;
      this.isMobile = /iPhone|iPad|iPod|Android/i.test(userAgent);

      document.getElementById('site-header').style.display = this.isMobile ? 'none' : 'block';
      document.getElementById('site-container').style.paddingTop = this.isMobile ? '0px' : '6.14rem';
    },
    touchStartEventHandler(e) {
      const { touches } = e;
      this.startX = touches[0].clientX;
      this.startY = touches[0].clientY;
    },
    touchEndEventHandler(e) {
      const { target, changedTouches } = e;
      const { clientX, clientY } = changedTouches[0];
      const isTable = target.closest('.premium-table');
      const absX = Math.abs(this.startX - clientX);
      const absY = Math.abs(this.startY - clientY);
      let activePage = this.active * 1;

      if (clientX < this.startX) {
        activePage = activePage + 1;
      }

      if (clientX > this.startX) {
        activePage = activePage - 1;
      }

      if (activePage === this.companies.length || activePage === -1) {
        return;
      }

      if (absX < absY) {
        return;
      }

      if (isTable) {
        this.movePagination(activePage);
      }
    },
    getReservationMemoAndReservationInflow() {
      const eventArr = ['event', 'gift', 'loc'];
      const queries = this.$route.query;
      const eventQueryParams = Object.keys(queries).filter(key => eventArr.indexOf(key) !== -1);
      const eventQueryParamsLength = eventQueryParams.length;
      let reservation_memo = '';
      let reservation_inflow = '';

      if (eventQueryParamsLength) {
        reservation_memo = '[';
        eventQueryParams
          .map((key, index) => {
            reservation_memo += queries[key];

            if (index < eventQueryParamsLength - 1) {
              reservation_memo += '-';
            }

            return key;
          })
          .filter((key, index) => {
            if (key !== 'gift') {
              reservation_inflow += queries[key];

              if (index < eventQueryParamsLength - 2) {
                reservation_inflow += '-';
              }
            }
          })

        reservation_memo += '] ';
      }

      if (this.selectedCompany.length) {
        reservation_memo += `${this.selectedCompany.join(', ')}로 상담을 원함`;
      } else {
        reservation_memo += '추천보험사 상담을 원함';
      }

      return {
        reservation_memo,
        reservation_inflow
      }
    },
    reservationNoneCustomer() {
      let { reservation_memo, reservation_inflow } = this.getReservationMemoAndReservationInflow();
      const { date, time } = this.$getDefaultConsultTime();

      const finalData = {
        customer_id: 0,
        reservation_inflow,
        title: "전화 상담 예약",
        checkmyinsure: this.checkmyinsure,
        전화상담: {
          step_datas: {
            consultDate: { title: '상담일시', value: date },
            consultTime: { title: '상담 에약 일시', value: time },
            insureName: { title: '보험종목', value: '운전자보험' },
            consultRemark: { title: '상담 전 남기실 말씀', value: reservation_memo },
            name: { title: '이름', value: this.formData.name },
            phone: { title: '휴대폰번호', value: this.formData.phoneNumber.split('-').join('') },
          }
        }
      };

      const queryItems = this.$route.query;

      fetch('https://api64.ipify.org?format=json')
        .then(x => x.json())
        .then(({ ip }) => {
          finalData.ip = ip;

          if (this.reservation_inflow_referer_source !== '') {
            finalData.reservation_inflow_referer_source = this.reservation_inflow_referer_source;
          }

          this.$store.dispatch( "reservation/createItems", finalData );
          
          this.close();
          this.$store.commit("elementModal/SET_ITEM", { elementId: "globalLifeEstimateResult", query: queryItems });
        });
    },
    uniqueInsuranceDetailInfo() {
      const companies = this.companies;
      let insuranceItems = [];
      companies.map(company => {
        const obj = this.lifeEstimateCompare.보험사항목정보[company][this.firstKey];
        const arr = Object.keys(obj).filter(key => obj[key].데이터1 !== 0);

        insuranceItems.push(arr);
      });

      const useKeys = Array
        .prototype
        .concat
        .apply([], insuranceItems)
        .reduce((prev, cur) => {
          if (prev.indexOf(cur) === -1) {
            prev.push(cur);
          }

          return prev;
        }, []);

      this.useKeys = useKeys;
    },
    getReciever() {
      if (!this.ca) {
        this.receiver = this.estimateData.admin_email;
      }
    },
    sendHangout({customerName, customerId, insuranceType}) {
      let content = `[홈페이지 견적서 방문] ${insuranceType}보험 차량 ${customerName}고객님께서 ${insuranceType}보험 보험료 비교표를 확인 중입니다./${this.id || 0}/${customerId || 0}`;

      // if (this.ca) {
      //   content = `[홈페이지 견적서 방문] ${customerName}고객님(${this.$route.query.ag}세 ${this.$route.query.sx} ${this.$route.query.jb})께서 ${insuranceType}보험 보험료 비교표를 확인 중입니다.`;
      // }

      this.$store.dispatch("etc/sendHangout", {
        rp: this.receiver,
        mg: content
      });
    },
    focusBirth(ref) {
      const $target = this.$refs[ref];
      const $input = $target.$children[0];
      const $el = $input.$el;

      $el.addEventListener('keyup', () => {
        const value = $input.value;
        let birth = value;

        if (value.length > 10) {
          birth = value.substr(0, 10);
        } else {
          birth = value.replace(/[^0-9]/g, '').replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
        }

        $target.userInput = birth;
      });

    },
    changeBirth() {
      const $target = this.$refs.birthDate;
      const pattern = /^(19[0-9][0-9]|20\d{2})-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;

      if (!pattern.test($target.value)) {
        this.formData.birth = '1980-01-01';
      }
    },
    _nasa(){
      var sh = document.getElementById("site-header")
      var tag = document.createElement('script')
      tag.src = "https://wcs.naver.net/wcslog.js"
      tag.type = "text/javascript"
      tag.async = true
      tag.onload = function(){
        var code_tag = document.createElement('script')
        code_tag.text = `
          var _nasa={};
          if(window.wcs) _nasa["cnv"] = wcs.cnv("1","10");
        `;
        sh.appendChild(code_tag)
      }
      sh.appendChild(tag);
    },
  }
}
</script>

<style lang="scss" scoped>
  #frame {
    background-color: white;

    .checkMyInsurance {
      text-align: center;
      margin-top: 2rem;
      position: relative;

      .el-checkbox {
        font-weight: 600;
        color: #191f28;

        span {
          &.grey-font {
            font-weight: 500;
            color: #8b95a1;
          }
        }

        .info-icon {
          vertical-align: middle;
          margin-left: 2px;
        }

        &.is-checked {
          /deep/ .el-checkbox__label {
            color: unset;
          }
        }
        /deep/ .el-checkbox__input {
          &.is-checked {
            .el-checkbox__inner {
              background-color: #174de5;
              border-color: #174de5;
            }
          }
          .el-checkbox__inner {
            border-radius: 50%;
            width: 18px;
            height: 18px;

            &::after {
              height: 7px;
              left: 5px;
              width: 5px;
              top: 2px;
            }
          }
        }
      }
    }
    .header{
      margin: 0 auto;
      padding: 50px;
      .cancelButton{
          width: 2rem;
          height: 2rem;
          background-image: url(/static/images/connection/close-white.png);
          background-size: 1rem;
          background-repeat: no-repeat;
          background-position: center;
          font-size: 16px;
          font-weight: 600;
          position: absolute;
          right: 20px;
          top: 2rem;
          cursor: pointer;
          background-color: #174de533;
          border-radius: 100%;
      }
      .head {
        margin-bottom: 20px;
        .title {
          font-size: 25px;
          text-align: center;
          font-weight: 600;
          line-height: 40px;
        }
        .sub {
          font-weight: 300;
          font-size: 14px;
          color: #adb5bd;
          text-align: center;
          margin-top: 2rem;

          i {
            vertical-align: middle;
          }
        }

        .section {
          text-align: center;
          margin: 20px auto;

          &.company {
            margin-top: 20px;
          }
          .button.reservation {
            height: 65px;
            width: 241px;
            background: #174de5;
            line-height: 65px;
            text-align: center;
            margin: 0 auto;
            color: white;
            font-size: 15px;
            font-weight: 600;
            cursor: pointer;
            &.disabled {
              cursor: not-allowed;
              background: #959595;
            }
            img {
              display: inline;
              margin-left: 30px;
              top: -3px;
            }
          }

          .round {
            display: flex;
            border: 1px solid #e5e8eb;
            border-radius: 50px;
            padding: 10px 5px;

            @include media-mobile {
              border-radius: 20px;
            }

            form {
              width: 100%;

              .birth-input {
                width: 100%;

                /deep/ .el-input__icon {
                  line-height: 31px;
                }
              }

              .el-form-item {
                margin-bottom: 0px;

                .el-input {
                  /deep/ .el-input__inner {
                    border: unset;
                    height: 31px;
                    line-height: 31px;
                  }
                }
                
                .el-radio {
                  margin-right: 20px;

                  &.is-checked {
                    /deep/ .el-radio__input {
                      .el-radio__inner {
                        border-color: #174de5;
                        background: #fff;
  
                        &::after {
                          background-color: #174de5;
                          width: 6px;
                          height: 6px;
                        }
                      }
                    }

                    /deep/ .el-radio__label {
                      color: #191f28;
                    }
                  }


                  /deep/ .el-radio__input {
                    .el-radio__inner {
                      border-color: #e5e8eb;
                      background: #e5e8eb;
                    }
                  }

                  /deep/ .el-radio__label {
                    padding-left: 5px;
                    color: #e5e8eb;
                  }
                }

                /deep/ .el-form-item__label {
                  line-height: 14px;
                  margin-left: 1rem;
                  font-weight: 600;
                }

                /deep/ .el-form-item__content {
                  line-height: 31px;
                }
              }

              /deep/ .el-form-item__error {
                margin-left: 1rem;
                padding-top: 0px;
              }

              .el-row {
                .form-input {
                  &:nth-child(n+0):nth-child(-n+3) {
                    .el-form-item {
                      &::after {
                        content: '';
                        position: absolute;
                        right: 0;
                        top: 10%;
                        height: 80%;
                        width: 1px;
                        background-color: #e5e8eb;
                      }
                    }
                    @include media-mobile {
                      &:nth-child(odd) {
                        .el-form-item {
                          margin-bottom: 5px;

                          &::after {
                            content: '';
                            position: absolute;
                            right: 0;
                            top: 10%;
                            height: 80%;
                            width: 1px;
                            background-color: #e5e8eb;
                          }
                        }
                      }
                      &:nth-child(even) {
                        .el-form-item {
                          margin-bottom: 5px;

                          &::after {
                            width: 0px;
                          }
                        }
                      }
                    }
                  }

                  @include media-mobile {
                    &:nth-child(even) {
                      margin-bottom: 5px;
                      padding-left: 0px !important;
                    }
                  }
                }

              }
            }

            &.blue {
              background-color: #174de5;
            }

            .first-input {
              width: calc(100% - 20px);
              margin-left: 20px;

              @include media-mobile {
                width: 100%;
                margin-left: 0px;
              }
            }

            .gender {
              /deep/ .el-form-item__label {
                width: 100%;
                text-align: left;
                margin-left: 0px !important;
              }

              /deep/ .el-form-item__content {
                text-align: left;
              }

              @include media-mobile {
                /deep/ .el-form-item__label {
                  padding-left: 12px;
                }
                /deep/ .el-form-item__content {
                  padding-left: 12px;
                }
              }
            }

            .submit-btn {
              border-radius: 50px;
              padding: 10px 0px;
              height: 45px;
              background-color: #174de5;
            }
          }
        }
      }

      .top {
        display: block;
        position: sticky;
        top: -27px;
        padding-bottom: 0.5*$unit;
        background-color: #fff;
        z-index: 1000;

        .table-pagination {
          display: inline-flex;
          position: relative;
          align-items: center;
  
          span {
            margin-right: 0.5*$unit;
            font-size: $unit;
          }
          .pagination-button {
            width: 1*$unit;
            height: 1*$unit;
            float: left;
            margin-right: 12px;
            background-color: #e6e6e6;
            border-radius: 20px;
            cursor: pointer;
            transition: 0.3s ease width;
            &.active {
              width: 2*$unit;
              background-color: #174de5;

              &:nth-child(3n + 2) {
                background-color: #d74946;
              }
              &:nth-child(3n + 3) {
                background-color: #b2a924;
              }
            }
          }

          @media screen and (max-width: 320px) {
            span {
              font-size: 12px;
            }
          }
        }
  
        .unit,
        .prev-next-btn {
          float: right;

          @media screen and (max-width: 320px) {
            button {
              font-size: 10px;

              &:last-child {
                margin-left: 5px;
              }
            }
            
          }
        }

        @include media-mobile {
          top: 0px;
        }
      }
      
      .premium-table {
        display: flex;
        font-size: 12px;
        font-weight: 300;
        .column {
          flex: 1;
          & span {
            white-space: nowrap;
            cursor: pointer;
          }
          .align-center {
            display: flex;
            align-items: center;
          }
          .text-right {
            text-align: right;
          }
          .text-center {
            text-align: center;
          }
          .col-sep {
            display: flex;
            .row {
              flex: 1;
            }
          }
          & > div {
            &:first-child {
              border-top: 2px solid #333d4b;
              position: sticky;
              top: 0px;
              z-index: 1000;
              background-color: #fff;

              @include media-mobile {
                top: 30px;
              }
            }
            border-bottom: 1px solid #eaeaea;
            height: 40px;
            line-height: 40px;
          }

          .h-58 {
            height: 58px;
            line-height: 58px;
          }

          .pt-cell {
            padding: 0 15px;

            * {
              color: #8b95a1;
            }
            &.right {
              text-align: right;
            }
            &.disable {
              display: none;
            }
          }
        }
        .bolder {
          font-weight: 800;
        }
        .fs-14 {
          font-size: 14px;
        }

        .f-500 {
          font-weight: 500 !important;
        }
        .f-400 {
          font-weight: 400 !important;
        }

        .info-icon {
          color: #191f28 !important;
          font-size: 16px;
          vertical-align: middle;
        }

        .color-black {
          color: #191f28 !important;
        }
        .line-cover {
          background: #fff1f1;
          &.blue {
            background: #edf5fd;
          }
        }

        .el-link {
          padding: 0px 20px;
          background-color: #e5e8eb;
          font-size: 12px;
          height: 25px;
          border-radius: 4px;

          /deep/ .el-link--inner {
            color: #191f28;
            font-weight: 600;
          }
        }

        @include media-mobile {
          flex-wrap: wrap;

          .column {
            flex: 0 1 50%;
            width: 50%;

            &.compare-company:nth-child(n+3) {
              display: none;
            }
          }
        }
      }

      @media screen and (max-width: 320px) {
        padding-right: 0.5*$unit !important;
      }
    }
    
    .bold {
      font-weight: bold;
    }
    .color-blue {
      color: #174de5;
    }
    .footer {
      &.pa-25 {
        padding: 25px;
        background: #e7edfc;
      }
      .title {
        text-align: center;
        font-size: 24px;
      }
      .sub {
        text-align: center;
        font-size: 14px;
        color: #adb5bd;
      }
      .company-list {
        display: inline-flex;
        padding: 0 20px;
        width: 100%;
        flex-wrap: wrap;
        justify-content: center;

        li {
          height: 50px;
          margin: 15px;
          display: flex;
          align-items: center;
          cursor: pointer;

          &::after {
            content: '';
            position: absolute;
            right: -15px;
            top: calc(50% - 19px);
            height: 38px;
            width: 1px;
            background-color: #e5e8eb;
          }

          &:last-child {
            &::after {
              width: 0px;
            }
          }

          span {
            padding: 8px;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: white;
            height: 79px;
            width: 79px;
            border-radius: 23%;
            border: 2px solid transparent;
            &.active {
              border: 2px solid #174de5;
            }
            & > img {
              max-height: 100%;
            }
          }

          .el-checkbox {
            margin-right: 5px;

            /deep/ .el-checkbox__input {
              .el-checkbox__inner {
                height: 24px;
                width: 24px;
                border-radius: 50%;
                background-color: #fff;
                border-color: #868686;

                &::after {
                  height: 11px;
                  left: 7px;
                  width: 6px;
                  top: 2px;
                }
              }
            }

            &.is-checked {
              /deep/ .el-checkbox__inner {
                background-color: #174de5;
                border-color: #174de5;

                &::after {
                  border-color: #fff;
                }
              }
            }
          }

          img {
            // display: inline-block;
          }
        }
      }
      .section {
        text-align: center;
        &.company {
          margin-top: 20px;
        }
        .button.reservation {
          height: 65px;
          width: 241px;
          background: #174de5;
          line-height: 65px;
          text-align: center;
          margin: 0 auto;
          color: white;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          &.disabled {
            cursor: not-allowed;
            background: #959595;
          }
          img {
            display: inline;
            margin-left: 30px;
            top: -3px;
          }
        }

        &.blue {
          padding: 0px;
          background: #174de5;
          margin-top: 0px;
          padding: 2rem 1rem;

          .checkMyInsurance {
            text-align: center;
            margin-bottom: 2rem;
            margin-top: 0;
            position: relative;

            &.bg-white {
              margin-bottom: 10px !important;
              margin-top: 10px !important;
              .el-checkbox {
                color: #191f28 !important;
                /deep/ .el-checkbox__input {
                  &.is-checked {
                    .el-checkbox__inner {
                      background-color: #174de5 !important;
                      border-color: #174de5 !important;
                    }
                  }
                  .el-checkbox__inner {

                    &::after {
                      border: 1px solid #fff !important;
                      border-left: 0 !important;
                      border-top: 0 !important;
                    }
                  }
                }
              }
            }

            .el-checkbox {
              font-weight: 600;
              color: #fff;

              span {
                &.grey-font {
                  font-weight: 500;
                  color: #8b95a1;
                }
              }

              .info-icon {
                vertical-align: middle;
                margin-left: 2px;
              }

              &.is-checked {
                /deep/ .el-checkbox__label {
                  color: unset;
                }
              }
              /deep/ .el-checkbox__input {
                &.is-checked {
                  .el-checkbox__inner {
                    background-color: #fff;
                    border-color: #fff;
                  }
                }
                .el-checkbox__inner {
                  border-radius: 50%;
                  width: 18px;
                  height: 18px;

                  &::after {
                    height: 7px;
                    left: 5px;
                    width: 5px;
                    top: 2px;
                    border: 1px solid #174de5;
                    border-left: 0;
                    border-top: 0;
                  }
                }
              }
            }
          }

          .round {
            display: flex;
            border: 1px solid #fff;
            border-radius: 50px;
            padding: 10px 5px;
            background: #fff;

            @include media-mobile {
              border-radius: 20px;
            }

            form {
              width: 100%;

              .birth-input {
                width: 100%;

                /deep/ .el-input__icon {
                  line-height: 31px;
                }
              }

              .el-form-item {
                margin-bottom: 0px;

                .el-input {
                  /deep/ .el-input__inner {
                    border: unset;
                    height: 31px;
                    line-height: 31px;
                  }
                }
                
                .el-radio {
                  margin-right: 20px;

                  &.is-checked {
                    /deep/ .el-radio__input {
                      .el-radio__inner {
                        border-color: #174de5;
                        background: #fff;
  
                        &::after {
                          background-color: #174de5;
                          width: 6px;
                          height: 6px;
                        }
                      }
                    }

                    /deep/ .el-radio__label {
                      color: #191f28;
                    }
                  }


                  /deep/ .el-radio__input {
                    .el-radio__inner {
                      border-color: #e5e8eb;
                      background: #e5e8eb;
                    }
                  }

                  /deep/ .el-radio__label {
                    padding-left: 5px;
                    color: #e5e8eb;
                  }
                }

                /deep/ .el-form-item__label {
                  line-height: 14px;
                  margin-left: 1rem;
                  font-weight: 600;
                }

                /deep/ .el-form-item__content {
                  line-height: 31px;
                }
              }

              /deep/ .el-form-item__error {
                margin-left: 1rem;
                padding-top: 0px;
              }


              .el-row {
                .form-input {
                  &:nth-child(n+0):nth-child(-n+3) {
                    .el-form-item {
                      &::after {
                        content: '';
                        position: absolute;
                        right: 0;
                        top: 10%;
                        height: 80%;
                        width: 1px;
                        background-color: #e5e8eb;
                      }
                    }
                    @include media-mobile {
                      &:nth-child(odd) {
                        .el-form-item {
                          margin-bottom: 5px;

                          &::after {
                            content: '';
                            position: absolute;
                            right: 0;
                            top: 10%;
                            height: 80%;
                            width: 1px;
                            background-color: #e5e8eb;
                          }
                        }
                      }
                      &:nth-child(even) {
                        margin-bottom: 5px;

                        .el-form-item {
                          &::after {
                            width: 0px;
                          }
                        }
                      }
                    }
                  }

                  @include media-mobile {
                    &:nth-child(even) {
                      margin-bottom: 5px;
                      padding-left: 0px !important;
                    }
                  }
                }
              }
            }

            &.blue {
              background-color: #174de5;
            }
            .first-input {
              width: calc(100% - 20px);
              margin-left: 20px;


              @include media-mobile {
                width: 100%;
                margin-left: 0px;
              }
            }

            .gender {
              /deep/ .el-form-item__label {
                width: 100%;
                text-align: left;
                margin-left: 0px !important;
              }

              /deep/ .el-form-item__content {
                text-align: left;
              }

              @include media-mobile {
                /deep/ .el-form-item__label {
                  padding-left: 12px;
                }
                /deep/ .el-form-item__content {
                  padding-left: 12px;
                }
              }
            }

            .submit-btn {
              border-radius: 50px;
              padding: 10px 0px;
              height: 45px;
              background-color: #174de5;
            }
          }
        }

      }
    }

    @include media-mobile {
      height: 100%;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 11px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #174de5;
      }
      &::-webkit-scrollbar-track {
        background-color: #e7edfc;
      }
      .header {
        padding: 50px $unit $unit $unit;

        .head {
          margin-bottom: 1.5*$unit;
        }
      }
    }
  }
</style>
<style lang="scss">
  #insu_calc_dlg {
    .el-dialog__headerbtn {
      width: auto;
    }
  }

  .element-snackbar {
    bottom: 3%;
  }



  .spinner-area {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1001;
    top: 0;
    left: 0;
    margin: auto;
    background-color: transparent;
    opacity: 1;
  
    > div {
      top: calc(50% - 100px);
      left: calc(50% - 100px);

      @include media-mobile {
        top: calc(50% - 100px);
      }
    }

    .sk-text {
      position: relative;
      text-align: center;
      top: 30%;
      font-size: 1.5*$unit;
      color: #fff;

      &.color-black {
        color: #000;
      }
      &.color-white {
        color: #fff;
      }
    }

    @keyframes ldio-tvytf13gwci {
      0% {
        transform: translate(12px, 80px) scale(0);
      }
    
      25% {
        transform: translate(12px, 80px) scale(0);
      }
    
      50% {
        transform: translate(12px, 80px) scale(1);
      }
    
      75% {
        transform: translate(80px, 80px) scale(1);
      }
    
      100% {
        transform: translate(148px, 80px) scale(1);
      }
    }
    
    @keyframes ldio-tvytf13gwci-r {
      0% {
        transform: translate(148px, 80px) scale(1);
      }
    
      100% {
        transform: translate(148px, 80px) scale(0);
      }
    }
    
    @keyframes ldio-tvytf13gwci-c {
      0% {
        background: #d74946
      }
    
      25% {
        background: #94b224
      }
    
      50% {
        background: #f0af31
      }
    
      75% {
        background: #0069ce
      }
    
      100% {
        background: #d74946
      }
    }
    
    .ldio-tvytf13gwci div {
      position: absolute;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      transform: translate(80px, 80px) scale(1);
      background: #d74946;
      animation: ldio-tvytf13gwci 1s infinite cubic-bezier(0, 0.5, 0.5, 1);
    }
    
    .ldio-tvytf13gwci div:nth-child(1) {
      background: #0069ce;
      transform: translate(148px, 80px) scale(1);
      animation: ldio-tvytf13gwci-r 0.25s infinite cubic-bezier(0, 0.5, 0.5, 1), ldio-tvytf13gwci-c 1s infinite step-start;
    }
    
    .ldio-tvytf13gwci div:nth-child(2) {
      animation-delay: -0.25s;
      background: #d74946;
    }
    
    .ldio-tvytf13gwci div:nth-child(3) {
      animation-delay: -0.5s;
      background: #0069ce;
    }
    
    .ldio-tvytf13gwci div:nth-child(4) {
      animation-delay: -0.75s;
      background: #f0af31;
    }
    
    .ldio-tvytf13gwci div:nth-child(5) {
      animation-delay: -1s;
      background: #94b224;
    }
    
    .loadingio-spinner-ellipsis-v3ytqcu5wu {
      width: 200px;
      height: 200px;
      display: inline-block;
      overflow: hidden;
    }
    
    .ldio-tvytf13gwci {
      width: 100%;
      height: 100%;
      position: relative;
      transform: translateZ(0) scale(1);
      backface-visibility: hidden;
      transform-origin: 0 0;
      /* see note above */
    }
    
    .ldio-tvytf13gwci div {
      box-sizing: content-box;
    }    
    /* generated by https://loading.io/ */
  }
</style>